import { render, staticRenderFns } from "./acts.vue?vue&type=template&id=41950262"
import script from "./acts.vue?vue&type=script&lang=js"
export * from "./acts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports